import { render } from "./sendManage.vue?vue&type=template&id=6b4c19da&scoped=true"
import script from "./sendManage.vue?vue&type=script&lang=js"
export * from "./sendManage.vue?vue&type=script&lang=js"

import "./sendManage.vue?vue&type=style&index=0&id=6b4c19da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b4c19da"

export default script